module.exports = __webpack_public_path__ + "static/media/grp_pic.65d630d7.jpg";